module.exports = __webpack_public_path__ + "menu.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/menu.svg?color1=%23333333&color2=
// module id = 2203
// module chunks = 67